import React, {
    useCallback,
    useEffect,
    useRef,
    useState,
    useMemo,
} from "react";
import style from "./AdminAddBulkStockNew.module.css";
import Select from "react-select";



export default function AddStockMiddleSection({ fields, categoriesData, filteredProducts,
    handledropdown, filteredDesigns, filteredPurity, collectionmainlist,
    allPacketNumbers, boxData, allSku, middlechange, selectedImages2 }) {



    const [previousFields, setPreviousFields] = useState([]);

    useEffect(() => {
        if (fields !== previousFields) {

            setPreviousFields(fields); // Update previousFields to trigger re-render on change
        }
    }, [fields]); // Re-run when 'fields' prop changes


    const [selectedWeights, setSelectedWeights] = useState([]);
    const [selectedsku, setSelectedsku] = useState({});

    // Use effect to handle changes in SKU or weights when fields or skuname changes
    // useEffect(() => {
    //     // Find the SKU field in 'fields' where key === 'SKU' and place === 'top'
    //     const skuname = fields.find(field => field.key === 'SKU' && field.place === 'top');
    //     if (skuname && skuname.value) {
    //         const ssku = allSku.find(sku => sku.Id === skuname.value);
    //         setSelectedsku(ssku || {});
    //     }
    // }, [fields, allSku]);

    useEffect(() => {
        if (selectedsku.WeightCategories) {
            const parsedWeights = selectedsku.WeightCategories.split(",")
                .map(Number)
                .filter(num => !isNaN(num));
            setSelectedWeights(parsedWeights);
        }
    }, [selectedsku]);


    const renderDropdownOptions = (fieldKey) => {
        switch (fieldKey) {
            case "CategoryId":
                return categoriesData.map((x, y) => (
                    <option key={y} value={x.Id}>
                        {x.CategoryName}
                    </option>
                ));
            case "ProductId":
                return filteredProducts('middle')?.map((x, y) => (
                    <option key={y} value={parseInt(x.Id)}>
                        {x.ProductName}
                    </option>
                ));
            case "PurityId":
                return filteredPurity('middle')?.map((x, y) => (
                    <option key={y} value={x.Id}>
                        {x.PurityName}
                    </option>
                ));
            case "DesignId":
                return filteredDesigns('middle')?.map((x, y) => (
                    <option key={y} value={x.Id}>
                        {x.DesignName}
                    </option>
                ));
            case "CollectionId":
                return collectionmainlist?.map((x, y) => (
                    <option key={y} value={x.Collection.Id}>
                        {x.Collection.CollectionName}
                    </option>
                ));
            case "PacketId":
                return allPacketNumbers.map((x, y) => (
                    <option key={y} value={parseInt(x.Id)}>
                        {x.PacketName}
                    </option>
                ));
            case "BoxId":
                return boxData.map((x, y) => (
                    <option key={y} value={x.Id}>
                        {x.BoxName}
                    </option>
                ));
            case "mainstone":
                return selectedsku?.SKUStoneMain?.map((stone, index) => (
                    <option key={index} value={stone.Id}>
                        {stone.StoneMainName}
                    </option>
                ));
            case "WeightCategory":
                return selectedWeights.map((weight, index) => (
                    <option key={index} value={weight}>
                        {weight}
                    </option>
                ));
            default:
                return null;
        }
    };

    return (
        <div className={style.adminAddCategoryMainBox2itemrows}>
            {fields
                .filter(field => field.place === "middle"
                    && field.visibility !== "Hidden"
                    && field.IsVisible !== "Hidden"
                )
                .sort((a, b) => a.priority - b.priority)
                .map((field, index) => {
                    if (field.type === "dropdown") {
                        return (
                            <div key={index} className={style.adminAddCategoryMainBox2itemfield}>
                                <label className={style.adminAddCategoryMainBox2label}>
                                    {field.label}
                                </label>
                                <select
                                    className={style.adminAddCategoryMainBox2select}
                                    value={field.value}
                                    onChange={(e) => handledropdown(field.key, e, "middle")}
                                >
                                    <option value="">Select</option>
                                    {renderDropdownOptions(field.key)}
                                </select>
                            </div>
                        );
                    }
                    if (field.type === "inputselect") {
                        return (
                            <div key={index} className={style.adminAddCategoryMainBox2itemfield}>
                                <label className={style.adminAddCategoryMainBox2label}>
                                    {field.label}
                                </label>
                                <select
                                    className={style.adminAddCategoryMainBox2select}
                                    value={field.value}
                                    onChange={(e) => handledropdown(field.key, e, "middle")}
                                >
                                    <option value="">Select</option>
                                    {renderDropdownOptions(field.key)}
                                </select>
                            </div>
                        );
                    }

                    if (field.type === "inputnumber" ||
                        field.type === "inputtext" ||
                        field.type === "inputdecimal") {
                        return (
                            <div
                                className={
                                    style.adminAddCategoryMainBox2itemfield
                                }
                            >
                                <label
                                    htmlFor=""
                                    className={
                                        style.adminAddCategoryMainBox2label
                                    }
                                >
                                    {field.label}
                                </label>
                                <input
                                    style={{ backgroundColor: "#FDFDFD", border: '1px solid #ddd' }}
                                    className={
                                        style.adminAddCategoryMainBox2input
                                    }
                                    onChange={(e) => {
                                        middlechange(e, field.key, "middle");
                                    }}
                                    value={field.value}
                                    disabled={
                                        field.visibility === "ReadOnly" ||
                                        field.IsVisible === "ReadOnly"
                                    }
                                    type={field.type === "inputtext"
                                        ? "text"
                                        : field.type === "inputnumber"
                                            ? "number"
                                            : "text" // Default to text for inputdecimal
                                    }
                                    onInput={(e) => {
                                        if (field.type === "inputnumber") {
                                            // Only allow numbers in inputnumber type
                                            e.target.value = e.target.value.replace(/[^0-9]/g, "");
                                        } else if (field.type === "inputdecimal") {
                                            // Allow numbers and one decimal point for inputdecimal type
                                            e.target.value = e.target.value.replace(/[^0-9.]/g, "").replace(/(\..*?)\..*/g, '$1');
                                        }
                                        // If it's inputtext, we allow everything, no restriction needed
                                    }}


                                />
                            </div>
                        )

                    }

                    if (field.type === 'popup') {
                        return (
                            <div
                                className={
                                    style.adminAddCategoryMainBox2itemfieldlast
                                }
                            >
                                <label
                                    htmlFor=""
                                    className={
                                        style.adminAddCategoryMainBox2label
                                    }
                                >
                                    {field.label}
                                </label>
                                <div className={style.inputgroup}>
                                    <input
                                        id="stone-input"
                                        type="text"
                                        value={
                                            selectedImages2
                                                ? selectedImages2.length
                                                : 0
                                        }
                                        // onChange={handleImageChange2}
                                        style={{
                                            margin: 0,
                                            border: "1px solid #ddd",
                                        }}
                                        className={style.inputfield}
                                        placeholder=""


                                    />
                                    <button
                                        className={style.addbutton}

                                        onClick={() => {
                                            console.log("test");
                                            // handleAddImage(); // Handle the add image logic
                                        }}
                                    >
                                        +
                                    </button>
                                </div>
                            </div>
                        )
                    }


                    if(field.type === 'inputselect'){
                        return(

                            <div>

                            </div>
                        )
                    }
                    return null;
                })}
        </div>
    );
}